import { storeImages } from "@/mocks/techData";

const contactItems = [
  { icon: "ri-map-pin-2-line", label: "Address", value: "86 Eastdale Road, Liverpool, L15 4HW" },
  { icon: "ri-phone-line", label: "Phone", value: "07909 324302", href: "tel:07909324302" },
  { icon: "ri-mail-line", label: "Email", value: "fistlimited007@gmail.com", href: "mailto:fistlimited007@gmail.com" },
];

export default function LocationSection() {
  return (
    <section id="visit" className="bg-background-50 py-20 md:py-28">
      <div className="container-x">
        <div className="mb-10 max-w-2xl md:mb-14">
          <p className="eyebrow mb-4 flex items-center gap-3">
            <span className="inline-block h-px w-8 bg-foreground-950"></span>
            Come and See Us
          </p>
          <h2 className="section-title">Visit Fist Limited.</h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600">
            Drop by the shop on Eastdale Road, or send us a message and we'll get back to you about
            mobiles, laptops and accessories in Liverpool.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1fr_1fr]">
          {/* Info */}
          <div className="flex flex-col">
            <div className="overflow-hidden rounded-xl">
              <div className="aspect-[4/3]">
                <img
                  src={storeImages.exterior}
                  alt="Exterior of Fist Limited technology shop on Eastdale Road, Liverpool"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>

            <div className="mt-6 space-y-4">
              {contactItems.map((c) => (
                <div key={c.label} className="flex items-center gap-4 rounded-lg bg-foreground-100 px-5 py-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-foreground-950 text-primary-400">
                    <i className={`${c.icon} text-lg`}></i>
                  </span>
                  <div>
                    <p className="font-label text-[10px] text-secondary-500">{c.label}</p>
                    {c.href ? (
                      <a href={c.href} className="text-sm text-foreground-950 hover:text-primary-600">
                        {c.value}
                      </a>
                    ) : (
                      <p className="text-sm text-foreground-950">{c.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <a
              href="https://www.google.com/maps/dir/?api=1&destination=86+Eastdale+Road+Liverpool+L15+4HW"
              target="_blank"
              rel="noopener nofollow"
              className="btn-dark mt-6 h-12 w-fit px-6 text-sm"
            >
              Get Directions <i className="ri-navigation-line"></i>
            </a>
          </div>

          {/* Map */}
          <div className="flex flex-col overflow-hidden rounded-xl border border-foreground-200 bg-foreground-50 p-6 md:p-8">
            <h3 className="font-heading text-xl text-foreground-950 md:text-2xl">Find us on Eastdale Road</h3>
            <p className="mt-2 text-sm text-foreground-600">
              86 Eastdale Road, Liverpool, L15 4HW
            </p>

            <div className="mt-6 flex-1 overflow-hidden rounded-lg border border-foreground-200">
              <iframe
                title="Map to Fist Limited, 86 Eastdale Road, Liverpool L15 4HW"
                src="https://www.google.com/maps?q=86+Eastdale+Road+Liverpool+L15+4HW&output=embed"
                className="h-72 w-full border-0 md:h-96"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="mt-6 rounded-lg bg-primary-100 p-4">
              <p className="text-sm text-primary-900">
                Prefer to chat? Call <a href="tel:07909324302" className="font-semibold hover:underline">07909 324302</a> or email <a href="mailto:fistlimited007@gmail.com" className="font-semibold hover:underline">fistlimited007@gmail.com</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}